// extracted by mini-css-extract-plugin
export default {"logoBox":"index_logoBox_KOPfx","logoImg":"index_logoImg_dLWCw","MottoImg":"index_MottoImg_e9-Ag"};